import { FC } from 'react';
import { MonitoringDateRange } from '../../monitoring/DateRange-Dropdown-util';
import PrometheusMonitoring from '@tecton/ComponentRedesign/Charts/PrometheusMonitoring';
import { format } from 'd3-format';
import { FCOFields, FeatureViewFCO } from '../../../core/types/fcoTypes';
import { PipelineNodeTypes } from '../../../service/Pipeline';
import { interval } from '../../../feature/feature-services/feature-service/component/ChartDefaultParams';
import { X_AXIS_LABEL } from '../../monitoring/GraphContainer';
import { filterDataForOnlyFeatureViews } from './utils';

interface FeatureViewsBelowFreshnessThresholdProps {
  featureViews: FeatureViewFCO[];
  graphType: number;
  monitoringDateRange: MonitoringDateRange;
}

const DynamoDBQPSPerTable: FC<FeatureViewsBelowFreshnessThresholdProps> = ({
  monitoringDateRange,
  featureViews,
  graphType,
}) => {
  const chartTitle = '';
  const yAxisLabel = 'Queries Per Second';

  const query = `sum(rate(cm_fv_read_count_no_instance{type=~'dynamo', tecton_cluster=~'.*',  aws_region=~'.*'}[${interval}])) by (feature_view_id)`;

  const yTicksCallback = (value: any) => {
    const formatter = format('.3~f');
    return `${formatter(value)} rd/s`;
  };

  const toolTipLabelCallback = (context: any) => {
    const { y } = context.parsed;
    const formatter = format('.3~f');

    const { label } = context.dataset;
    const labelText = `${label}: ${formatter(y)} rd/s`;
    return labelText;
  };

  const getMetricLabelCallback = (result: any) => {
    // Matches the Feature View ID (which is in the dataset)
    // to the Feature View Name (which is in FeatureViews)
    // Ensures that charts render properly

    return featureViews.find((fv) => fv.id === result.metric.feature_view_id)?.[FCOFields.NAME] ?? '';
  };

  const yOverride = {
    title: {
      display: true,
      text: yAxisLabel,
      font: {
        size: 12,
      },
    },
    min: 0,

    ticks: {
      callback: yTicksCallback,
    },
  };

  return (
    <>
      <PrometheusMonitoring
        chartTitle={chartTitle}
        monitoringDateRange={monitoringDateRange}
        queries={[{ label: 'Value', query: query }]}
        xAxisLabel={X_AXIS_LABEL}
        yAxisLabel={yAxisLabel}
        yTicksCallback={yTicksCallback}
        yGrace={0}
        toolTipLabelCallback={toolTipLabelCallback}
        yOverride={yOverride}
        parseValue={parseFloat}
        getMetricLabelCallback={getMetricLabelCallback}
        height={160}
        transformData={(data) => {
          return filterDataForOnlyFeatureViews(data, featureViews);
        }}
      />
    </>
  );
};

export default DynamoDBQPSPerTable;
